<template>
  <div class="flex shrink-0 basis-[calc(100%-0.75rem)] flex-col items-center md:w-[calc(100%-0.75rem)] md:flex-row">
    <UiImage
      v-if="item.avatar"
      :id="`review-avatar-${item.id}`"
      class="mb-8 size-40 rounded-full md:mb-0"
      :src="item.avatar.url"
      :alt="item.avatar.alt_text ?? item.full_name"
    />
    <div class="flex flex-col self-start text-left md:ml-14">
      <UiRating :id="`review-${item.id}`" :value="item.note" :max="5" size="xs" />

      <UiText type="p" class="mb-8 mt-2">{{ item.content }}</UiText>

      <UiText class="font-bold">{{ item.full_name }}</UiText>
      <UiText class="text-neutral-500">{{ item.job_title }}</UiText>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PageTestimonialProps } from '~/components/Page/types';

defineProps<PageTestimonialProps>();
</script>
